'use client'

import Image from 'next/image'
import { cn } from '../lib/cn'
import { trackEvent } from '../lib/analytics'
import type { StoreLinks } from '../lib/storeLinks'
import { downloadTranslations, DownloadLocale } from '../translations/download'

interface StoreBadgesProps {
  locale: string
  links: StoreLinks
  className?: string
}

/** Official App Store / Google Play badges (locale-matched) linking to attributed store URLs. */
export function StoreBadges({ locale, links, className }: StoreBadgesProps) {
  const t = downloadTranslations[locale as DownloadLocale] || downloadTranslations.en
  const lang = locale === 'de' ? 'de' : 'en'
  const badges = [
    {
      key: 'app_store',
      href: links.appStore,
      src: `/images/invite/icon_download_apple-app-store_dark_${lang}.svg`,
      alt: t.appStoreAlt,
    },
    {
      key: 'google_play',
      href: links.playStore,
      src: `/images/invite/icon_download_google-play_dark_${lang}.svg`,
      alt: t.playStoreAlt,
    },
  ]

  return (
    <div className={cn('flex flex-col items-center gap-4 sm:flex-row sm:justify-center', className)}>
      {badges.map((badge) => (
        <a
          key={badge.key}
          href={badge.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={badge.alt}
          onClick={() => trackEvent('click', 'download', badge.key)}
          className="inline-flex transition-transform hover:-translate-y-0.5"
        >
          <Image src={badge.src} alt={badge.alt} width={180} height={54} className="h-[54px] w-auto" />
        </a>
      ))}
    </div>
  )
}
